import { render } from "./ReSearch.vue?vue&type=template&id=4000097f"
import script from "./ReSearch.vue?vue&type=script&lang=js"
export * from "./ReSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__